import { UserRoles } from "common/enums";
import * as appRoutes from "config/routes.config";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ContactUs from "screens/teacher/components/contactUs";
import AnimatedPage from "utils/animatedPage";

const RecrutementPage = () => {

    //!HOOKS
    const { t } = useTranslation();
    const auth = useSelector((state) => state.auth);
    const { isAppInMaintenance } = useSelector((state) => state.auth);
    const navigate = useNavigate();

    //!EFFECTS
    useEffect(() => {
        const isLoggedIn = auth.isLoggedIn;
        const isTeacher = auth.user?.roles?.includes(UserRoles.TEACHER);
        const isStudent = auth.user?.roles?.includes(UserRoles.STUDENT);
        if (isLoggedIn && isTeacher) return navigate(appRoutes.TEACHER_ACTIVITIES);
        if (isLoggedIn && isStudent) return navigate(appRoutes.TEACHER_ACTIVITIES);
    }, [auth.isLoggedIn, navigate, auth.user?.roles]);

    useEffect(() => {
        if (isAppInMaintenance) {
            navigate(appRoutes.MAINTENANCE);
        };
    }, [isAppInMaintenance]);

    return (
        <AnimatedPage>
            <ContactUs from="teacher" />
        </AnimatedPage>
    );
};

export default RecrutementPage;
